import type { TherapistListRequest } from '@hedepy/common/schemas/routes/api/v2/therapist'
import { useMemo } from 'react'

import { useGetFilterValue } from '@/legacy-src/components/filters/hooks/useGetFilterValue'
import useServices from '@/legacy-src/hooks/useServices'

import { useGetTherapistsList } from '@/src/domains/therapist/hooks/useGetTherapistList'
import { getTherapistListRequestParams } from '@/src/domains/therapist/utils/getTherapistListRequestParams'

export const useGetFilteredTherapistList = () => {
  const { selectedServiceId } = useServices()

  const filterTimesValue = useGetFilterValue('times')
  const filterDaysValue = useGetFilterValue('days')
  const filterInDaysValue = useGetFilterValue('availability')
  const filterSessionTypeValue = useGetFilterValue('sessionType')
  const filterSessionLocationValue = useGetFilterValue('sessionLocation')

  const params = useMemo(
    (): TherapistListRequest | undefined =>
      getTherapistListRequestParams({
        filterDaysValue,
        filterTimesValue,
        filterInDaysValue,
        filterSessionTypeValue,
        filterSessionLocationValue,
        selectedServiceId,
      }),
    [
      filterDaysValue,
      filterInDaysValue,
      filterTimesValue,
      filterSessionTypeValue,
      filterSessionLocationValue,
      selectedServiceId,
    ],
  )

  const { data, isLoading } = useGetTherapistsList(params)

  return { data, isLoading }
}
